export default __webpack_public_path__ + "static/media/chevron-right.b4400deb.svg";